import Box from "@mui/material/Box";
// eslint-disable-next-line import/no-cycle
import SiteContext from "components/SiteContext";
import Button from "components/templatesComponents/Button";
import Link from "components/templatesComponents/Link";
import PropTypes from "prop-types";
import React, { useContext } from "react";
import { accentColorDsfrTypes } from "utils/colorDsfrTypes";

const InfoBlock = (props) => {
  const { icon = {}, title = "", text = null, link = {}, sx = {} } = props;
  let { accentColor = "" } = props;
  const { iconDSFR } = icon;
  const { title: titleLink, page, url } = link;

  const site = useContext(SiteContext);

  const { name: siteName } = site || {};

  if (!accentColor) {
    switch (siteName) {
      case "IMMAT":
      case "PHA":
        accentColor = "orange-terre-battue";
        break;
      case "PERMIS":
      case "AUTO_ECOLE":
        accentColor = "purple-glycine";
        break;
      case "PASSEPORT_CNI":
      case "MAIRIE":
        accentColor = "green-archipel";
        break;
      default:
        break;
    }
  }

  let calloutClassName = "fr-callout";
  if (iconDSFR) {
    calloutClassName += ` fr-icon-${iconDSFR}`;
  }
  if (accentColor && accentColor !== "default") {
    calloutClassName += ` fr-callout--${accentColor}`;
  }

  return (
    <Box className={calloutClassName} sx={sx}>
      <h3 className="fr-callout__title">{title}</h3>
      <div className="fr-callout__text">{text}</div>
      {(url || page?.path) && (
        <Button component={Link} basic {...link}>
          {titleLink}
        </Button>
      )}
    </Box>
  );
};

InfoBlock.propTypes = {
  icon: PropTypes.shape(),
  title: PropTypes.string,
  text: PropTypes.node,
  link: PropTypes.shape(),
  accentColor: PropTypes.oneOf(accentColorDsfrTypes),
  sx: PropTypes.shape(),
};

export default InfoBlock;
